import React, { createContext, useCallback, useContext, useState } from 'react';

export interface PreselectedScenarioContextValue {
	/** The scenario ID to pre-select in VoiceAgentModal */
	preselectedScenarioId: string | null;
	/** Set the preselected scenario ID */
	setPreselectedScenarioId: (id: string | null) => void;
	/** Clear the preselected scenario ID */
	clearPreselectedScenarioId: () => void;
}

const PreselectedScenarioContext = createContext<PreselectedScenarioContextValue | null>(null);

export const PreselectedScenarioProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [preselectedScenarioId, setPreselectedScenarioIdState] = useState<string | null>(null);

	const setPreselectedScenarioId = useCallback((id: string | null) => {
		setPreselectedScenarioIdState(id);
	}, []);

	const clearPreselectedScenarioId = useCallback(() => {
		setPreselectedScenarioIdState(null);
	}, []);

	const value: PreselectedScenarioContextValue = {
		preselectedScenarioId,
		setPreselectedScenarioId,
		clearPreselectedScenarioId,
	};

	return <PreselectedScenarioContext.Provider value={value}>{children}</PreselectedScenarioContext.Provider>;
};

export const usePreselectedScenario = (): PreselectedScenarioContextValue => {
	const context = useContext(PreselectedScenarioContext);
	if (!context) {
		throw new Error('usePreselectedScenario must be used within a PreselectedScenarioProvider');
	}
	return context;
};
